// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Teisaldatud ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' toiming on lõpule viidud',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' toiming on pooleli',
  accColorPalette: () => 'Värvipalett',
  accColorSwatch: () => 'Värvinäidis',
  accCommandKey: () => 'Käsk',
  accContextMenuLabel: () => 'toimingud',
  accControlKey: () => 'Sule',
  accPositionAfter: () => 'pärast',
  accPositionBefore: () => 'enne',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Vajutage pikalt klahvi ' +
    p['keyPressed'] +
    ' jatõstuklahve, seejärel kasutage ümberjärjestamiseks nooleklahve.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Sisestage täielik kuupäev nii: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Sisestage kuu ja aasta nii: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Silt',
  chart_labelGroup: () => 'Rühm',
  chart_labelSeries: () => 'Sari',
  chart_labelValue: () => 'Väärtus',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Valige väärtus.',
  checkbox_helpForCheckbox: () => 'Märkeruudu spikker',
  checkbox_requiredMessageDetail: () => 'Valige väärtus.',
  checkbox_selected: () => 'Märkeruut on märgitud',
  checkbox_unselected: () => 'Märkeruut pole märgitud',
  close: () => 'Sule',
  collection_apply: () => 'Rakenda',
  collection_cancel: () => 'Loobu',
  collection_loaded: () => 'Laaditud',
  collection_loading: () => 'Laadimine',
  collection_noData: () => 'Kuvatavaid andmeid pole.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Muuda veeru suurust',
  collection_resizeColumnMenu: () => 'Muuda veeru suurust...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Sisestage arv vahemikus ' + p['MIN'] + '–' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Vali kõik read',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vali rida ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Kasvav',
  collection_sortColumnMenu: () => 'Sortimisveerg',
  collection_sortDescendingSubMenu: () => 'Kahanev',
  collection_sortDisabled: () => 'Mittesorditav',
  collection_sortEnabled: () => 'Sorditav',
  collection_width: () => 'Laius',
  colorPicker_label: () => 'Värvivalija',
  confirmation: () => 'Kinnitus',
  datePicker_currentDate: () => 'Praegune kuupäev',
  datePicker_goToToday: () => 'Saate minna tänasele.',
  datePicker_label: () => 'Kuupäevavalija',
  datePicker_month: () => 'Kuu',
  datePicker_months: () => 'Kuud',
  datePicker_next: () => 'Järgmine',
  datePicker_nextDecade: () => 'Järgmine kümnend',
  datePicker_nextMonth: () => 'Järgmine kuu',
  datePicker_prev: () => 'Eelmine',
  datePicker_prevDecade: () => 'Eelmine kümnend',
  datePicker_prevMonth: () => 'Eelmine kuu',
  datePicker_restricted: () => 'Piiratud',
  datePicker_selected: () => 'Valitud',
  datePicker_today: () => 'Täna',
  datePicker_weekNum: (p: { NUM: string }) => 'Nädal ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Nädala number',
  datePicker_year: () => 'Aasta',
  datePicker_years: () => 'Aastad',
  diagram_promotedLink: () => '1 link',
  diagram_promotedLinkAriaDesc: () => 'Kaudne',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' linki',
  error: () => 'Tõrge',
  expandableList_expandCollapseInstructionText: () =>
    'Kasutage laiendamiseks ja ahendamiseks nooleklahve',
  expandableList_groupCollapse: () => 'Ahendatud',
  expandableList_groupExpand: () => 'Laiendatud',
  filePicker_addFiles: () => 'Lisa failid',
  filePicker_dropzonePrimaryText: () => 'Pukseeri',
  filePicker_dropzoneSecondaryText: () => 'Valige fail või pukseerige see siia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valige failid või pukseerige need siia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Üles saate korraga laadida ühe faili',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'tundmatu',
  formControl_clear: () => 'Tühjenda',
  formControl_day: () => 'Päev',
  formControl_empty_segment: () => 'Tühi',
  formControl_helpAvailable: () => 'Spikker on saadaval',
  formControl_hide: () => 'Peida',
  formControl_hour: () => 'Tund',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Limiit ' +
    ((
      { one: new Intl.NumberFormat('et').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('et').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('et').format(p['CHARACTER_LIMIT']) + '-character') +
    ' on täis.',
  formControl_loading: () => 'Laadimine',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Saate sisestada kuni ' + p['MAX_LENGTH'] + ' märki.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumpikkus ' + p['MAX_LENGTH'] + ' on ületatud.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Järele on jäänud ' + p['CHARACTER_COUNT'] + ' märki.',
  formControl_millisecond: () => 'Millisekund',
  formControl_minute: () => 'Minut',
  formControl_month: () => 'Kuu',
  formControl_readOnly: () => 'Kirjutuskaitstud',
  formControl_requiredMessageDetail: () => 'Sisestage väärtus.',
  formControl_second: () => 'Sekund',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Valige ' + p['n'] + ' väärtust.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Valikulimiit (' + p['max'] + ') on täis.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Valige ' + p['min'] + ' kuni ' + p['max'] + ' väärtust.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Valige vähemalt ' + p['min'] + ' väärtust.',
  formControl_show: () => 'Kuva',
  formControl_year: () => 'Aasta',
  gantt_labelDate: () => 'Kuupäev',
  gantt_labelEnd: () => 'Lõpp',
  gantt_labelLabel: () => 'Silt',
  gantt_labelRow: () => 'Rida',
  gantt_labelStart: () => 'Algus',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastavat jaotist ei leitud.',
  indexer_keyboardInstructionText: () => 'Väärtuse valimiseks vajutage sisestusklahvi.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Vahemikus ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Topeltpuudutage ja hoidke žestirežiimi aktiveerimisekst ning seejärel lohistage väärtuse kohandamiseks üles või alla.',
  info: () => 'Teave',
  inputColor_selectColor: () => 'Valige värv',
  inputDateMask_date_cleared: () => 'Kuupäev on eemaldatud',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tühi',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Sisestage kuupäev, mis on ' + p['max'] + ' või varasem.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Sisestage kuupäev, mis on ' + p['min'] + ' või hilisem.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Sisestage saadaolev kuupäev.',
  inputDatePicker_instruction: () => 'Kalendri avamiseks vajutage tabeldusklahvi.',
  inputDatePicker_selectDate: () => 'Vali kuupäev',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Sisestage kuu ja kuupäev, mis on ' + p['max'] + ' või nendest varasem.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Sisestage kuu ja kuupäev, mis on ' + p['min'] + ' või nendest hilisem.',
  inputNumber_converterParseError: () => 'Sisestage number.',
  inputNumber_decrease: () => 'Vähendamine',
  inputNumber_increase: () => 'Suurendamine',
  inputPassword_hidden: () => 'Parool on peidetud',
  inputPassword_hide: () => 'Peida parool',
  inputPassword_show: () => 'Kuva parool',
  inputSensitiveText_hidden: () => 'Tundliku lomuga tekst on peidetud',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Sisestage aeg, mis on ' + p['max'] + ' või varasem.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Sisestage aeg, mis on ' + p['min'] + ' või hilisem.',
  inputTimeMask_time_cleared: () => 'Aeg on eemaldatud',
  labelNone: () => 'Puudub',
  list_msgFetchCompleted: () => 'Laaditud',
  list_msgFetchingData: () => 'Laadimine',
  list_suggestion: () => 'Soovitus',
  menu_stateLoading: () => 'Laadimine',
  messageToast_allMessagesClosed: () => 'Kõik töölaua sõnumid on suletud.',
  message_close: () => 'Sule',
  message_confirmation: () => 'Õnnestus',
  message_error: () => 'Tõrge',
  message_info: () => 'Teave',
  message_navigationFromMessagesRegion: () =>
    'Sõnumite alasse liikumine. Vajutage liikumiseks klahvi F6.',
  message_navigationToMessagesRegion: () =>
    'Sõnumite alal on uusi sõnumeid. Vajutage liikumiseks klahvi F6.',
  message_navigationToTouch: () => 'Sõnumite alal on uusi sõnumeid.',
  message_warning: () => 'Hoiatus',
  noData_message: () => 'Kuvatavaid üksusi pole',
  overflowItemLabel: () => 'Rohkem vahekaarte',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Avatud hüpikakna sulgemiseks topeltpuudutage.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Hüpikaknasse sisenemine. Hüpikakna ja seostatud juhtelemendi vahel liikumiseks vajutage klahvi F6.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Hüpikaken on avatud. Hüpikakna ja seostatud juhtelemendi vahel liikumiseks vajutage klahvi F6.',
  progressIndeterminate: () => 'Pooleli',
  radioButton_checked: () => 'Raadionupp on märgitud',
  radioButton_selected: () => 'Raadionupp on valitud',
  radioButton_unchecked: () => 'Raadionuppu pole märgitud',
  radioButton_unselected: () => 'Raadionuppu pole valitud',
  radio_helpForRadio: () => 'Raadionupu spikker',
  radio_requiredMessageDetail: () => 'Valige väärtus.',
  selectMultiple_apply: () => 'Rakenda',
  selectMultiple_back: () => 'Tagasi',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Valitud väärtuste esiletõstmiseks kasutage parem- ja vasaknoolt.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Valitud väärtuse eemaldamiseks vajutage tagasilükkeklahvi või klahvi Kustuta.',
  selectMultiple_selectedValues: () => 'Valitud väärtused',
  selectMultiple_showSelectedValues: () => 'Kuva ainult valitud väärtused.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Valitud on ' + p['VALUE_COUNT'] + ' väärtust.',
  select_addToList: () => 'Lisa loendisse',
  select_addToListAvailable: () => 'Loendisse lisamine on saadaval',
  select_closeDropdown: () => 'Sulgemiseks vajutage paoklahvi (Esc).',
  select_moreSearchOptions: () => 'Veel otsingusuvandeid',
  select_moreSearchOptionsAvailable: () => 'Saadaval on veel otsingusuvandeid',
  select_noMatchesFound: () => 'Vasteid ei leitud.',
  select_oneMatchFound: () => 'Leiti üks vaste',
  select_requiredMessageDetail: () => 'Valige väärtus.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Leiti ' + p['TOTAL_SIZE'] + ' vastet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Leiti ' + p['TOTAL_SIZE'] + ' või rohkem vastet',
  selectorAll_deselectAll: () => 'Tühistage kogu valik',
  selectorAll_selectAll: () => 'Vali kõik',
  selector_selected: () => 'Märkeruut on märgitud',
  selector_unselected: () => 'Märkeruut pole märgitud',
  sheet_close: () => 'Sule',
  switch_off: () => 'Väljas',
  switch_on: () => 'Sees',
  tabBarNavigationList_removeCueText: () => 'Eemaldatav',
  tabBar_tabContainsErrors: () => 'Sisaldab vigu',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Eemaldatud ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'sisaldab kontekstimenüüd',
  tabbar_labelMoveLeft: () => 'Teisalda vasakule',
  tabbar_labelMoveRight: () => 'Teisalda paremale',
  tabbar_labelRemove: () => 'Eemalda',
  timeComponent_tooltipZoomIn: () => 'Suurenda',
  timeComponent_tooltipZoomOut: () => 'Vähenda',
  timeConverter_parseError: () => 'Sisestage täielik kellaaeg.',
  train_current: () => 'Praegune',
  train_message_type: () => 'Sõnumitüüp',
  train_not_visited: () => 'Pole külastatud',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Samm ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => 'Külastatud',
  userAssistance_learnMore: () => 'Lisateave',
  userAssistance_required: () => 'Kohustuslik',
  vis_clearSelection: () => 'Tühjenda valik',
  vis_drillable: () => 'Süvitsiminekuks sobiv',
  vis_invalidData: () => 'Andmed ei sobi',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Valikuraam',
  vis_marqueeZoomTooltip: () => 'Suumimisraam',
  vis_noData: () => 'Kuvatavaid andmeid pole',
  vis_panTooltip: () => 'Panoraami',
  vis_stateCollapsed: () => 'Ahendatud',
  vis_stateExpanded: () => 'Laiendatud',
  vis_stateLoaded: () => 'Laaditud',
  vis_stateLoading: () => 'Laadimine',
  vis_stateSelected: () => 'Valitud',
  vis_stateUnselected: () => 'Valimata',
  warn: () => 'Hoiatus'
};
export default bundle;
